export default "__VITE_ASSET__9f51cf22__"